export const localesWithFlags = [{
  code: 'en',
  imagePath: '/images/png/engFlag.png',
  allowedCountries: ['GE', 'AM'],
}, {
  code: 'ka',
  imagePath: '/images/png/geoFlag.png',
  allowedCountries: ['GE'],
}, {
  code: 'am',
  imagePath: '/images/png/armFlag.png',
  allowedCountries: ['AM'],
}, {
  code: 'ru',
  imagePath: '/images/png/ruFlag.png',
  allowedCountries: ['AM'],
}];

export const locales = ['en', 'ka', 'am', 'ru'];
